export var ChangePasswordErrorCode;
(function (ChangePasswordErrorCode) {
    ChangePasswordErrorCode["CURRENT_PASSWORD_INVALID"] = "CURRENT_PASSWORD_INVALID";
    ChangePasswordErrorCode["PASSWORD_REUSED"] = "PASSWORD_REUSED";
    ChangePasswordErrorCode["PASSWORD_CHANGE_UNAVAILABLE"] = "PASSWORD_CHANGE_UNAVAILABLE";
    ChangePasswordErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
})(ChangePasswordErrorCode || (ChangePasswordErrorCode = {}));
//# sourceMappingURL=user.types.js.map